import { render, staticRenderFns } from "./DictionaryManage.vue?vue&type=template&id=643ad7f8&"
import script from "./DictionaryManage.vue?vue&type=script&lang=js&"
export * from "./DictionaryManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports